import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { supabase } from "../lib/supabase";

export function useSpecificRoleAccess() {
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    async function checkAccess() {
      try {
        if (!user) {
          setHasAccess(false);
          return;
        }

        const { data: workerData, error } = await supabase
          .from("workers")
          .select("role_id")
          .eq("user_id", user.id)
          .single();

        if (error) {
          console.error("Error checking specific role access:", error);
          setHasAccess(false);
          return;
        }

        // Check if role_id is 6
        setHasAccess(workerData.role_id === 6);
      } catch (err) {
        console.error("Error checking specific role access:", err);
        setHasAccess(false);
      } finally {
        setLoading(false);
      }
    }

    checkAccess();
  }, [user]);

  return { hasAccess, loading };
}
